module.exports = __webpack_public_path__ + "static/recursiveMenu-cc1a482d02e0de2d818eadfbe6d7dbf5.gif";